// src/components/BrandMark.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Wheat } from 'lucide-react';
import { DISPLAY_FONT, SITE } from '../siteInfo';

const SIZES = {
  sm: { seal: 34, icon: 17, name: '1.15rem', gap: 1.1 },
  md: { seal: 42, icon: 21, name: '1.45rem', gap: 1.35 },
  lg: { seal: 50, icon: 25, name: '1.7rem', gap: 1.5 },
};

/**
 * The wordmark, drawn once so the header and the footer can never drift apart.
 * `tone` is the surface it is sitting on, not the colour of the mark: 'light'
 * means a pale surface and dark type, 'dark' means the deep olive footer and
 * cream type. The seal keeps its olive in both, so the brand colour survives
 * even where the type has to invert.
 */
const BrandMark = ({ size = 'md', tone = 'light' }) => {
  const s = SIZES[size] || SIZES.md;
  const onDark = tone === 'dark';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: s.gap }}>
      <Box
        aria-hidden
        sx={{
          width: s.seal,
          height: s.seal,
          flexShrink: 0,
          borderRadius: '30% 30% 30% 30% / 32% 32% 32% 32%',
          display: 'grid',
          placeItems: 'center',
          color: '#f7f4e9',
          background: 'linear-gradient(145deg, #7b9440 0%, #556b2f 55%, #435522 100%)',
          backgroundColor: '#556b2f',
          boxShadow: onDark
            ? '0 2px 10px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.22)'
            : '0 3px 12px rgba(85,107,47,0.32), inset 0 1px 0 rgba(255,255,255,0.28)',
        }}
      >
        <Wheat size={s.icon} strokeWidth={1.9} />
      </Box>

      <Typography
        component="span"
        sx={{
          fontFamily: DISPLAY_FONT,
          fontSize: s.name,
          fontWeight: 600,
          letterSpacing: '-0.015em',
          lineHeight: 1.1,
          whiteSpace: 'nowrap',
          color: onDark ? '#f4f1e6' : 'text.primary',
        }}
      >
        {SITE.name}
      </Typography>
    </Box>
  );
};

export default BrandMark;
